const NoScript = () => {
  return (
    <section className="berg-page-no-script">
      <h1>No Script - please enable JavaScript support in Your Browser.</h1>
    </section>
  );
};

export default NoScript;
